import { ReduxUtils } from '../../../dependencies';
import types from '../../actionTypes';

const actionTypes = {
    REQUEST: types.UPDATE_SUPPLIER_REQUEST,
    SUCCESS: types.UPDATE_SUPPLIER_SUCCESS,
    FAILURE: types.UPDATE_SUPPLIER_FAILURE,
    CANCEL: types.UPDATE_SUPPLIER_CANCEL,
};

const basicReducer = ReduxUtils.basicApiReducer({
    actionTypes,
});

export default ReduxUtils.containerReducer({
    childReducer: basicReducer,
    actionTypes: Object.values(actionTypes),
    selectors: {
        itemId: action => action.meta.id,
    },
});
